export const formatAsCurrency = (amount, currency = "EUR", locale = "de-DE") =>
  new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
  }).format(amount)
